import { InternshipLocationService } from 'data/services';
import { InternshipLocationServiceInterface } from 'domain/services';
import { makeGetInternshipLocation } from 'main/factories/usecases/internship-location/remote-get-internship-location-factory';

export const makeInternshipLocationService =
  (): InternshipLocationServiceInterface => {
    return new InternshipLocationService(makeGetInternshipLocation());
  };
